import { z } from 'zod';

export const ZohoUser = z.object({
  zoho_user_id: z.string(),
  name: z.string(),
  email: z.string()
});
export type ZohoUser = z.infer<typeof ZohoUser>;

export const User = ZohoUser.extend({
  id: z.string()
});
export type User = z.infer<typeof User>;

// Auth-resolution variant: zoho_user_id is nullable because an Entra-authenticated
// user may have no Zoho counterpart (JIT-provisioned with zoho_user_id = null).
// The strict User/UserType/TeamUser chain above stays non-nullable.
export const AuthUser = User.extend({
  zoho_user_id: z.string().nullable()
});
export type AuthUser = z.infer<typeof AuthUser>;

export const UserType = User.extend({
  rep_type: z.string()
});
export type UserType = z.infer<typeof UserType>;

// Dev Panel user switcher: each user with their distinct rep roles (empty for team-less users).
export const DevUser = AuthUser.extend({
  roles: z.array(z.string())
});
export type DevUser = z.infer<typeof DevUser>;

export const TeamUser = UserType.extend({
  team_id: z.string(),
  team_name: z.string()
});
export type TeamUser = z.infer<typeof TeamUser>;
